import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import getTableViewFromTableQuery from 'mini-mail-list-actions/lib/actions/tables/getTableViewFromTableQuery';
import { createSearchTableQuery } from '../utils/createSearchTableQuery';
import { getSearchSourceFromConfig } from 'mini-search-common/lib/utils/getSearchSourceFromConfig';
import { logMailResultsView } from '../utils/logMailResultsView';
import { on3SSearchResultsFetchStart } from 'mini-3s-search-common-actions/lib/actions/publicActions';
import { orchestrator } from 'satcheljs';
import { setSelectedTableViewId } from 'mini-mail-list-actions/lib/actions/tables/setSelectedTableViewId';
import { startMailSearch } from '../actions/publicActions';
import { TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';
import {
    executeMailSearch,
    incrementSearchNumber,
    setSearchSource,
} from '../actions/privateActions';

/**
 * Orchestrator which starts the mail search by loading the initial table and tableQuery
 */
export default orchestrator(startMailSearch, () => {
    const selectedTableView = getCurrentSelectedTableView();
    const isDataCached = selectedTableView?.tableQuery?.type === TableQueryType.Search;

    on3SSearchResultsFetchStart(isDataCached, logMailResultsView);

    // A fresh start should only happen if there is no existing search tableView.
    // We remove the search tableView on exit from results screen
    if (isDataCached) {
        return;
    }

    /** Increment searchNumber on every search */
    incrementSearchNumber();

    /**Set the correct search source based on userSetting */
    const searchSourceToBeUsed = getSearchSourceFromConfig();
    setSearchSource(searchSourceToBeUsed);

    /** create and get a new tableView */
    const newSearchTableQuery = createSearchTableQuery();
    const newTableView = getTableViewFromTableQuery(newSearchTableQuery);
    setSelectedTableViewId(newTableView.id);

    executeMailSearch();
});
